var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTdesignTimeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 130.333C33.575 130.333 5.66669 102.425 5.66669 68.0001C5.66669 33.5751 33.575 5.66675 68 5.66675C102.425 5.66675 130.333 33.5751 130.333 68.0001C130.333 102.425 102.425 130.333 68 130.333ZM73.6667 31.1667H62.3334V70.3461L85 93.0127L93.0127 85.0001L73.6667 65.6541V31.1667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTdesignTimeFilled);
export default __webpack_public_path__ + "static/media/tdesign_time-filled.225c900a2cd285dcaab3a040aec22e8f.svg";
export { ForwardRef as ReactComponent };